var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef, AfterViewInit, EventEmitter, NgZone } from '@angular/core';
import { ZevensterAreaService } from './zevenster-area.service';
import { ZevensterAjaxService } from '../zevenster-ajax/zevenster-ajax.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
var viewInitComplete;
var ɵ0 = function (res) { return viewInitComplete = res; };
var viewInitCompletePromise = new Promise(ɵ0);
var ZevensterAreaComponent = /** @class */ (function () {
    function ZevensterAreaComponent(zevensterAreaService, zevensterAjaxService, elementRef, zone, router) {
        this.zevensterAreaService = zevensterAreaService;
        this.zevensterAjaxService = zevensterAjaxService;
        this.elementRef = elementRef;
        this.zone = zone;
        this.router = router;
        this.svg = this.zevensterAreaService.parsedSvg;
        this.passive = false;
        this.looselyFocus = false;
        this.hidePurchased = false;
        this.withPurchasedHover = false;
        this.withPurchaseLink = false;
        this.canSelectPurchased = false;
        this.clickSquare = new EventEmitter();
        this.selectSquare = new EventEmitter();
    }
    ZevensterAreaComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.focusedSquare$)
            this.focusedSquare$.subscribe(function (squareId) { return _this.setFocus(squareId, true, 'selected', _this.looselyFocus); });
        if (this.unfocusedSquare$)
            this.unfocusedSquare$.subscribe(function (squareId) { return _this.setFocus(squareId, false, 'selected', _this.looselyFocus); });
        var checkLoaded = function () {
            setTimeout(function () {
                if (_this.elementRef.nativeElement.querySelector('rect')) {
                    viewInitComplete();
                }
                else {
                    checkLoaded();
                }
            }, 10);
        };
        checkLoaded();
    };
    ZevensterAreaComponent.prototype.setFocus = function (squareId, focus, klass, loosely) {
        if (loosely === void 0) { loosely = false; }
        return __awaiter(this, void 0, void 0, function () {
            var rect;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, viewInitCompletePromise];
                    case 1:
                        _a.sent();
                        rect = this.elementRef.nativeElement.querySelector("rect[square-id='" + squareId + "']");
                        if (loosely && !rect)
                            return [2 /*return*/];
                        if (focus) {
                            rect.setAttribute(klass || 'selected', '');
                        }
                        else {
                            rect.removeAttribute(klass || 'selected');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ZevensterAreaComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.passive)
            return;
        var rects = Array.from(this.elementRef.nativeElement.querySelectorAll('rect'));
        this.rects = rects;
        var selectRect = function (rect) {
            // if (rect.hasAttribute('purchased')) return;
            _this.zone.run(function () {
                for (var _i = 0, _a = rect.getAttribute('square-all-ids').split(','); _i < _a.length; _i++) {
                    var squareId = _a[_i];
                    _this.selectSquare.emit(parseInt(squareId));
                }
                _this.clickSquare.emit(parseInt(rect.getAttribute('square-id')));
            });
        };
        var highlightPurchasedRect = function (rect, yes) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!rect.hasAttribute('purchased'))
                    return [2 /*return*/];
                this.zone.run(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _a = this.highlightPurchase;
                                return [4 /*yield*/, this.getPurchaseFromRect(rect)];
                            case 1:
                                _a.apply(this, [_b.sent(), yes]);
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        var _loop_1 = function (rect) {
            rect.addEventListener('mousedown', function () { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(!rect.hasAttribute('purchased') || this.canSelectPurchased)) return [3 /*break*/, 1];
                            console.log(rect);
                            selectRect(rect);
                            return [3 /*break*/, 3];
                        case 1:
                            if (!this.withPurchaseLink) return [3 /*break*/, 3];
                            _a = this.goToCertificate;
                            return [4 /*yield*/, this.getPurchaseFromRect(rect)];
                        case 2:
                            _a.apply(this, [_b.sent()]);
                            _b.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            if (this_1.withPurchasedHover) {
                rect.addEventListener('mouseleave', function () {
                    highlightPurchasedRect(rect, false);
                });
                rect.addEventListener('mouseenter', function () {
                    highlightPurchasedRect(rect, true);
                });
            }
        };
        var this_1 = this;
        for (var _i = 0, rects_1 = rects; _i < rects_1.length; _i++) {
            var rect = rects_1[_i];
            _loop_1(rect);
        }
        if (!this.hidePurchased)
            this.focusPurchasedAreas();
    };
    ZevensterAreaComponent.prototype.focusPurchasedAreas = function () {
        return __awaiter(this, void 0, void 0, function () {
            var areaIds;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.zevensterAjaxService.fetchPurchasedAreaIds()];
                    case 1:
                        areaIds = _a.sent();
                        areaIds.forEach(function (i) { return _this.setFocus(i, true, 'purchased', true); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ZevensterAreaComponent.prototype.highlightPurchase = function (p, yes) {
        var container = this.elementRef.nativeElement;
        var areas = p.fields.areas;
        if (areas.length >= 9 && areas.length % 9 === 0)
            areas = areas.filter(function (sqId) { return !(sqId % 3); });
        var lowestSqId = 100000;
        for (var _i = 0, areas_1 = areas; _i < areas_1.length; _i++) {
            var sqId = areas_1[_i];
            var el = container.querySelector("rect[square-id='" + sqId + "']");
            lowestSqId = Math.min(lowestSqId, sqId);
            if (el)
                yes ? el.setAttribute('highlighted', '') : el.removeAttribute('highlighted');
        }
        var firstRect = container.querySelector("rect[square-id='" + lowestSqId + "']");
        var highlightBox = container.querySelector('.highlight-box');
        if (yes) {
            var highlightBoxName = highlightBox.querySelector('.highlight-box-name');
            var highlightBoxArea = highlightBox.querySelector('.highlight-box-area');
            var r = container.clientWidth / 800;
            highlightBox.style.left = firstRect.x.baseVal.value * r + 'px';
            highlightBox.style.top = firstRect.y.baseVal.value * r - 65 + 'px';
            highlightBox.style.display = 'block';
            highlightBoxName.innerHTML = p.fields.user_display_name;
            highlightBoxArea.innerHTML = p.fields.total_area;
        }
        else {
            highlightBox.style.display = 'none';
        }
    };
    ZevensterAreaComponent.prototype.getPurchaseFromRect = function (rect) {
        return __awaiter(this, void 0, void 0, function () {
            var sqId, purchases, _i, purchases_1, p;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sqId = parseInt(rect.getAttribute('square-id'));
                        return [4 /*yield*/, this.zevensterAjaxService.fetchPurchases()];
                    case 1:
                        purchases = _a.sent();
                        for (_i = 0, purchases_1 = purchases; _i < purchases_1.length; _i++) {
                            p = purchases_1[_i];
                            if (p.fields.areas.indexOf(sqId) > -1) {
                                return [2 /*return*/, p];
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ZevensterAreaComponent.prototype.goToCertificate = function (p) {
        this.router.navigate(['/zevensterbos', 'certificaten', p.fields.id]);
    };
    return ZevensterAreaComponent;
}());
export { ZevensterAreaComponent };
export { ɵ0 };
//# sourceMappingURL=zevenster-area.component.js.map